module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}



//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/is-promise/index.js
// module id = 114
// module chunks = 0 1 2 3 4 5 6 7 8 9 10